import React, { Component } from 'react'
import { Navigate } from 'react-router-dom'

import { connect } from "react-redux"
import { increment, decrement } from "../../features/counter/counterSlice"
import { setLoggedIn } from "../../features/account/loginSlice"
import { setAccount } from "../../features/account/accountSlice"
import { setCompany } from "../../features/account/companySlice"

import axios from "axios"
import qs from 'qs'
import DatePicker from "react-datepicker"
import Swal from 'sweetalert2'

import { hidePreloader, showPreloader } from '../../library/helper'
import { withTranslation } from 'react-i18next'
import { withRouter } from '../../components/withRouter'

import "react-datepicker/dist/react-datepicker.css"

import InputNumeric from '../../components/InputNumeric'

export class ReductionUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            redirectEmission: false,
            selectedDate: new Date(Date.now()),

            listCompany: [],
            selectedCompany: 0,

            listEmissionFactor: [],
            listEmissionFactorUnit: [],
            bauFactor: 0,
            bauUnit: 0,
            bauMultiplier: 1,
            bauAmount: 0,
            existingRecKwh: 0,

            certNumber: '',
            certEmissionFactor: 0,
            amount: 0,
            remarks: '',

            reductionUuid: '',
            originalAmountKwh: 0,
        }
    }

    componentDidMount = async () => {
        showPreloader()

        const data = {}

        const [responseGetCompany, responseGetEmissionFactor, responseGetEmissionFactorUnit] = await Promise.all([
            axios({ withCredentials: true, method: 'POST', headers: { 'content-type': 'application/x-www-form-urlencoded' }, data: qs.stringify(data), url: `${process.env.REACT_APP_BASE_SERVER}/client/get_all` }),
            axios({ withCredentials: true, method: 'POST', headers: { 'content-type': 'application/x-www-form-urlencoded' }, data: qs.stringify(data), url: `${process.env.REACT_APP_BASE_SERVER}/emission_factor/emission_factor` }),
            axios({ withCredentials: true, method: 'POST', headers: { 'content-type': 'application/x-www-form-urlencoded' }, data: qs.stringify(data), url: `${process.env.REACT_APP_BASE_SERVER}/emission_factor/emission_factor_unit` }),
        ])

        const listCompany = responseGetCompany.data.success ? responseGetCompany.data.data : []
        const listEmissionFactor = responseGetEmissionFactor.data.success ? responseGetEmissionFactor.data.data : []
        const listEmissionFactorUnit = responseGetEmissionFactorUnit.data.success ? responseGetEmissionFactorUnit.data.data : []

        // Load existing record
        const { id } = this.props.params
        const responseRead = await axios({
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify({ id }),
            url: `${process.env.REACT_APP_BASE_SERVER}/reduction/read`
        })

        if (responseRead.data.success && responseRead.data.data.length > 0) {
            const rec = responseRead.data.data[0]
            const recDate = new Date(rec.reduction_date)
            const originalAmountKwh = parseFloat(rec.reduction_actual_amount || 0)

            this.setState({
                listCompany, listEmissionFactor, listEmissionFactorUnit,
                reductionUuid: rec.reduction_uuid,
                selectedDate: recDate,
                selectedCompany: rec.reduction_client || 0,
                bauFactor: rec.reduction_bau_factor,
                bauUnit: rec.reduction_actual_factor || 0,
                certNumber: rec.cert_number || '',
                certEmissionFactor: rec.cert_emission_factor || 0,
                amount: (originalAmountKwh / 1000),  // kWh -> MWh for display
                remarks: rec.remarks || '',
                originalAmountKwh,
            })

            // Fetch electricity usage — subtract this record's own amount from existingRecKwh
            const payload = { year: recDate.getFullYear(), factorId: rec.reduction_bau_factor }
            if (rec.reduction_client) payload.company = rec.reduction_client
            try {
                const responseUsage = await axios({
                    withCredentials: true, method: 'POST',
                    headers: { 'content-type': 'application/x-www-form-urlencoded' },
                    data: qs.stringify(payload),
                    url: `${process.env.REACT_APP_BASE_SERVER}/reduction/electricity-usage-by-year`
                })
                if (responseUsage.data.success) {
                    this.setState({
                        bauAmount: responseUsage.data.data.total,
                        existingRecKwh: (responseUsage.data.data.existingRecKwh || 0) - originalAmountKwh,
                    })
                }
            } catch (_) {}
        } else {
            this.setState({ listCompany, listEmissionFactor, listEmissionFactorUnit })
        }

        hidePreloader()
    }

    onSelectDate = (e) => {
        const datePick = new Date(new Date(e).getFullYear(), new Date(e).getMonth(), 7)
        this.setState({ selectedDate: datePick })
    }

    onInputText = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    onInputAmount = (values, sourceInfo) => {
        if (sourceInfo?.event?.target?.name && values) {
            this.setState({ [sourceInfo.event.target.name]: values.value })
        }
    }

    onSelectCompany = async (e) => {
        const companyId = e.target.value
        this.setState({
            selectedCompany: companyId,
            bauFactor: 0, bauUnit: 0, bauMultiplier: 1, bauAmount: 0, existingRecKwh: 0,
            listEmissionFactor: [],
        })
        await this.fetchEmissionFactors(companyId)
    }

    fetchEmissionFactors = async (companyId) => {
        const payload = {}
        if (companyId && companyId != 0) payload.company = companyId
        const response = await axios({
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(payload),
            url: `${process.env.REACT_APP_BASE_SERVER}/emission_factor/emission_factor`
        })
        if (response.data.success) {
            this.setState({ listEmissionFactor: response.data.data })
        }
    }

    fetchElectricityUsage = async (factorId) => {
        const year = new Date(this.state.selectedDate).getFullYear()
        const payload = { year, factorId }
        if (this.state.selectedCompany && this.state.selectedCompany != 0) {
            payload.company = this.state.selectedCompany
        }
        try {
            const response = await axios({
                withCredentials: true, method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(payload),
                url: `${process.env.REACT_APP_BASE_SERVER}/reduction/electricity-usage-by-year`
            })
            if (response.data.success) {
                this.setState({
                    bauAmount: response.data.data.total,
                    existingRecKwh: (response.data.data.existingRecKwh || 0) - this.state.originalAmountKwh,
                })
            }
        } catch (_) {}
    }

    onSelectBauFactor = async (e) => {
        const factorId = e.target.value
        this.setState({ bauFactor: factorId, bauUnit: 0, bauMultiplier: 1 })
        if (factorId && factorId != 0) {
            await this.fetchElectricityUsage(factorId)
        }
    }

    onSelectBauUnit = (e) => {
        const { listEmissionFactorUnit } = this.state
        // eslint-disable-next-line
        const filtered = listEmissionFactorUnit.filter(item => item.unit_id == e.target.value)
        this.setState({
            bauUnit: e.target.value,
            bauMultiplier: filtered.length > 0 ? filtered[0].unit_multiplier : 1,
        })
    }

    onSaveRecord = async () => {
        const {
            certNumber, certEmissionFactor, amount, remarks, selectedDate,
            bauFactor, bauUnit, bauMultiplier, bauAmount, listEmissionFactor,
            selectedCompany, reductionUuid,
        } = this.state

        if (!bauFactor || bauFactor == 0) {
            Swal.fire({ title: '', html: '<p>Please select a grid</p>', confirmButtonColor: '#3085d6', confirmButtonText: 'Ok' })
            return
        }
        if (!certNumber.trim()) {
            Swal.fire({ title: '', html: '<p>Please enter the REC ID/Number</p>', confirmButtonColor: '#3085d6', confirmButtonText: 'Ok' })
            return
        }
        if (!parseFloat(certEmissionFactor) || parseFloat(certEmissionFactor) <= 0) {
            Swal.fire({ title: '', html: '<p>Please enter a valid emission factor</p>', confirmButtonColor: '#3085d6', confirmButtonText: 'Ok' })
            return
        }
        if (!parseFloat(amount) || parseFloat(amount) <= 0) {
            Swal.fire({ title: '', html: '<p>Please enter the REC purchased amount</p>', confirmButtonColor: '#3085d6', confirmButtonText: 'Ok' })
            return
        }

        const amountKwh = parseFloat(amount) * 1000
        const { existingRecKwh } = this.state
        const remainingKwh = parseFloat(bauAmount) - existingRecKwh
        if (amountKwh > remainingKwh) {
            Swal.fire({
                title: '',
                html: `<p>REC Purchased Amount exceeds available grid electricity.</p>` +
                    `<p>Grid total: ${(parseFloat(bauAmount) / 1000).toFixed(0)} MWh<br/>` +
                    `Existing RECs: ${(existingRecKwh / 1000).toFixed(0)} MWh<br/>` +
                    `Remaining available: ${(remainingKwh / 1000).toFixed(0)} MWh</p>`,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok',
            })
            return
        }

        // eslint-disable-next-line
        const filteredBauFactor = listEmissionFactor.filter(item => item.emission_factor_id == bauFactor && item.cf_category == 7)
        const bauEF = filteredBauFactor.length > 0 ? parseFloat(filteredBauFactor[0].emission_factor) : 0
        const bauTotal = parseFloat(bauAmount) * parseFloat(bauMultiplier) * bauEF
        const actualTotal = amountKwh * parseFloat(certEmissionFactor)

        const response = await axios({
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify({
                id: reductionUuid,
                bauFactor,
                bauAmount,
                bauTotal,
                actualAmount: amountKwh,
                actualTotal,
                certNumber,
                certEmissionFactor,
                remarks,
                date: selectedDate,
                company: selectedCompany || undefined,
            }),
            url: `${process.env.REACT_APP_BASE_SERVER}/reduction/update`
        })

        if (!response.data.success) {
            Swal.fire({ title: '', html: '<p>Failed to update, please try again</p>', confirmButtonColor: '#3085d6', confirmButtonText: 'Ok' })
        } else {
            Swal.fire({ title: '', html: '<p>Successfully updated</p>', confirmButtonColor: '#3085d6', confirmButtonText: 'Ok' })
                .then((result) => {
                    if (result.isConfirmed) this.setState({ redirectEmission: true })
                })
        }
    }

    render() {
        const {
            redirectEmission, selectedDate,
            listCompany, selectedCompany,
            listEmissionFactor, listEmissionFactorUnit,
            bauFactor, bauUnit, bauAmount, existingRecKwh,
            certNumber, certEmissionFactor, amount, remarks,
        } = this.state

        if (redirectEmission) {
            return <Navigate to={'/reduction'} />
        }

        const optionBauFactor = []
        if (bauFactor == 0) optionBauFactor.push(<option key={0} value={0}>Select Grid Name</option>)
        listEmissionFactor.forEach((item, index) => {
            // eslint-disable-next-line
            if (item.cf_category == 7) optionBauFactor.push(<option key={index + 1} value={item.emission_factor_id}>{item.emission_name}</option>)
        })

        const optionBauUnit = []
        if (bauUnit == 0) optionBauUnit.push(<option key={0} value={0}>Select Unit</option>)
        if (bauFactor != 0) {
            listEmissionFactorUnit.forEach((item, index) => {
                // eslint-disable-next-line
                if (item.unit_factor == bauFactor) optionBauUnit.push(<option key={index + 1} value={item.unit_id}>{item.unit_label}</option>)
            })
        }

        return (
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Renewable Energy Certificate</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Edit</h4>
                                </div>
                                <div className="card-body">

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Action Category</label>
                                                <input className="form-control" value="Renewable Energy Certificate" readOnly />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Renewable Energy Sources</label>
                                                <input className="form-control" value="Electricity Consumption" readOnly />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {listCompany.length > 1 && (
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Company / Subsidiary</label>
                                                    <select onChange={this.onSelectCompany} value={selectedCompany} className="form-select mb-0">
                                                        {!selectedCompany && <option value={0}>Select Company</option>}
                                                        {listCompany.map((item) => (
                                                            <option key={item.company_client} value={item.company_client}>{item.company_name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Purchased Date</label>
                                                <div>
                                                    <DatePicker selected={selectedDate} onChange={(date) => this.onSelectDate(date)} dateFormat="MMMM yyyy" className="form-select mb-3" showMonthYearPicker />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Imported Electricity Grid</label>
                                                <select onChange={this.onSelectBauFactor} value={bauFactor} className="form-select mb-0">
                                                    {optionBauFactor}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Imported Electricity Amount (kWh)
                                                    <span style={{ fontSize: '11px', color: '#6c757d', marginLeft: '6px' }}>(auto-filled)</span>
                                                </label>
                                                <InputNumeric id="bauAmount" name="bauAmount" value={bauAmount} onValueChange={this.onInputAmount} placeholder={this.props.t('emission.form.enter')} style={{ backgroundColor: '#e9ecef' }} disabled />
                                                {parseFloat(bauAmount) > 0 && (
                                                    <p className="mt-1 mb-0" style={{ fontSize: '12px', color: '#6c757d' }}>
                                                        Existing RECs: <strong>{(existingRecKwh / 1000).toFixed(0)} MWh</strong>
                                                        {' | '}
                                                        Remaining: <strong style={{ color: (parseFloat(bauAmount) - existingRecKwh) > 0 ? '#198754' : '#dc3545' }}>
                                                            {((parseFloat(bauAmount) - existingRecKwh) / 1000).toFixed(0)} MWh
                                                        </strong>
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">REC ID/Number/Unit</label>
                                                <input type="text" name="certNumber" value={certNumber} onChange={this.onInputText} className="form-control" placeholder={this.props.t('emission.form.enter')} />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">REC Emissions Factor (tCO₂e/kWh)</label>
                                                <InputNumeric id="certEmissionFactor" name="certEmissionFactor" value={certEmissionFactor} onValueChange={this.onInputAmount} placeholder={this.props.t('emission.form.enter')} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">REC Purchased Amount (MWh)</label>
                                                <InputNumeric id="amount" name="amount" value={amount} onValueChange={this.onInputAmount} placeholder={this.props.t('emission.form.enter')} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label">Remarks</label>
                                                <textarea name="remarks" value={remarks} onChange={this.onInputText} className="form-control" rows={3} placeholder="Optional notes" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="text-end">
                                                <button onClick={this.onSaveRecord} type="submit" className="btn btn-primary">{this.props.t('general.btnSave')}</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    count: state.counter.value,
    loggedIn: state.loggedIn.value,
    account: state.account.value,
    company: state.company.value,
})

const mapDispatchToProps = { increment, decrement, setLoggedIn, setAccount, setCompany }

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ReductionUpdate)))
